const INFO = {
	main: {
		title: "Reactfolio by Nandish Naik",
		name: "Naik",
		email: "naik.nandishd@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/NandishNai7939",
		github: "https://github.com/NandishNaik01",
		linkedin: "https://www.linkedin.com/in/nandishd/",
		instagram: "https://www.instagram.com/the__restless___/",
		facebook: "https://www.facebook.com/profile.php?id=61552420581922",
	},

	homepage: {
		title: "' Aspiring Professional '",
		description:
			"I've had the privilege of working on a diverse range of projects throughout my journey, and I take great pride in the progress I've achieved. Many of these projects are open-source, inviting others to explore and actively participate. If any of these initiatives pique your interest, I encourage you to delve into the codebase and suggest potential enhancements or improvements. Collaboration is a wonderful avenue for personal growth and learning, and I'm continually receptive to fresh ideas and constructive feedback.",
	},

	about: {
		title: (
			<div>
				Nandish D, From{" "}
				<span style={{ color: "orange", fontWeight: "bold" }}>
					" भारत "
				</span>
				<br />
				where I craft tomorrow's possibilities.
			</div>
		),
		description:
			"I've had the privilege of working on a diverse range of projects throughout my journey, and I take great pride in the progress I've achieved. Many of these projects are open-source, inviting others to explore and actively participate. If any of these initiatives pique your interest, I encourage you to delve into the codebase and suggest potential enhancements or improvements. Collaboration is a wonderful avenue for personal growth and learning, and I'm continually receptive to fresh ideas and constructive feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description: "collection of my long-form thoughts on programming.",
	},

	projects: [
		{
			title: "Project 1 : Gita Quotes",
			description:
				"I have created an Android app for reading Bhagavad Gita quotes chapter-wise,",
			logo: "https://e1.pngegg.com/pngimages/736/783/png-clipart-macos-app-icons-android-studio.png",
			linkText: "View Project",
			link: "https://github.com/NandishNaik01/GitaQuotes",
		},

		{
			title: "Project 2 : CALCO",
			description:
				"This web project uniquely addresses the problem of calculating trade sizes based on your daily risk and per-trade risk, while considering your total capital. It can suggest sizes in lots or individual units. .",
			logo: "https://www.pngfind.com/pngs/m/685-6854994_react-logo-no-background-hd-png-download.png",
			linkText: "View Project",
			link: "https://lotcalco.netlify.app/",
		},

		{
			title: "Project 3 : Swift-Apply Assistant! ",
			description:
				"Swift Apply Assistant is a Chrome extension that automates Google Forms filling. Users can store key-value pairs for form labels and data,",
			logo: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjD0AdFDHozAJN_5mTAc4J4VmFp0moDBbtc4AgJXLCbN3q_1T4A5PpUXOaMayQq96spfEt2qIzdQ_WzPayVazqO9JdCgS0YxuedjbpkDcXHtfwKhvh9wem1t-Bq5d7_U7gG-VaXVCdtjX0/s1600/Chrome.png",
			linkText: "View Project",
			link: "https://github.com/NandishNaik01/Auto-Form-Filler---Using-Js-For-Dom-Manipulation",
		},

		{
			title: "Project 4 : Password manager App",
			description:
				"The PassWord Manager app! Built using Jetpack Compose, Kotlin, Room Database, and AES encryption, it offers a secure solution for managing passwords on Android. Features include biometric authentication for added security and a user-friendly interface designed to streamline password management tasks.",
			logo: "https://cdn.getmidnight.com/26ffcef53c44522efbfe7fef964a4058/2023/02/untitled-1-.png",
			linkText: "View Project",
			link: "https://github.com/NandishNaik01/password-manager-Application-Using-Jetpac-compose-and-kotlin",
		},
	],
};

export default INFO;
